/** Which input the conditions builder shows for the value of a rule. */
export enum ConditionValueKindEnum {
  TEXT = 'text',
  NUMBER = 'number',
  DATE = 'date',
  DATE_TIME = 'date_time',
  SELECT = 'select',
  MULTI_SELECT = 'multi_select',
  /** A users lookup: one user for `is` / `is_not`, several for `is_any_of`. */
  USER = 'user',
}
